export const GITHUB: string = 'https://github.com/kieranroneill';
export const LIKNEDIN: string = 'https://www.linkedin.com/in/kieranroneill';
export const TWITTER: string = 'https://twitter.com/kieranroneill';
